import { DISCORD_URL } from "@/lib/config";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/[0.06] mt-12"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-end">
          <div className="md:col-span-2">
            <div className="font-display text-6xl sm:text-7xl lg:text-8xl font-semibold tracking-tighter text-gradient-white leading-none">
              Origin<span className="text-gradient-gold">PS</span>
            </div>
            <p className="mt-4 max-w-md text-sm text-slate-400">
              An independent Growtopia private server experience. Not
              affiliated with Ubisoft or the official Growtopia game.
            </p>
          </div>
          <div className="space-y-3">
            <a
              href={DISCORD_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-join-discord"
              className="block text-sm text-slate-300 hover:text-white transition-colors"
            >
              Discord →
            </a>
            <a
              href="#features"
              data-testid="footer-link-features"
              className="block text-sm text-slate-300 hover:text-white transition-colors"
            >
              Features →
            </a>
            <a
              href="#how-to-play"
              data-testid="footer-link-how-to-play"
              className="block text-sm text-slate-300 hover:text-white transition-colors"
            >
              How to play →
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/[0.06] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} OriginPS. All rights reserved.
          </p>
          <p className="text-xs text-slate-500">
            Crafted with care for the OriginPS community.
          </p>
        </div>
      </div>
    </footer>
  );
}
